<script>
  // What a long press (phone), right-click (desktop) or the menu key on a
  // Project tile opens (BundleShelf's `menupress`): the app's one menu,
  // shared/ContextMenu, by the tile, with the Project's Source Link
  // (CONTEXT.md: the deck or cube on its own site, never a Binder Browser
  // binder view) and, for the owner, Remove. A Project with no Source Link
  // yet shows no link; with nothing to offer, nothing opens. It renders at
  // the end of <body>, above the app's fixed menu button.
  import ContextMenu from '../shared/ContextMenu.svelte';
  import { portal } from '../../lib/actions/portal.js';

  /**
   * @type {{
   *   project: import('../../lib/logic/want-page-logic.js').ShelfProject,
   *   name: string,
   *   count?: number,
   *   icon?: string | null,
   *   anchor?: HTMLElement | null,
   *   onRemove?: (() => void) | null,
   *   onClose: () => void,
   * }}
   */
  let { project, name, count = 0, icon = null, anchor = null, onRemove = null, onClose } = $props();

  /** @type {import('svelte').ComponentProps<typeof ContextMenu>['items']} */
  const items = $derived([
    ...(project.source_url
      ? [
          {
            label: project.source_url.replace(/^https?:\/\/(www\.)?/, ''),
            href: project.source_url,
            icon,
          },
        ]
      : []),
    ...(onRemove ? [{ label: 'Remove project', variant: 'danger', onClick: onRemove }] : []),
  ]);
</script>

{#if items.length}
  <div use:portal>
    <ContextMenu
      isOpen
      {items}
      title={count ? `${name} (${count})` : name}
      anchorElement={anchor}
      focusFirst
      {onClose}
    />
  </div>
{/if}
